module.exports = __webpack_public_path__ + "img/S1-Typhoon-Idai.e5b0ca33.png";